var _path, _g, _g2, _path2, _path3, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarth1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3000,
    height: 1424,
    viewBox: "0 0 3000 1424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1941 248C3161.12 248 4142 1101.98 4142 2146C4142 3190.02 3161.12 4044 1941 4044C720.882 4044 -260 3190.02 -260 2146C-260 1101.98 720.882 248 1941 248Z",
    fill: "url(#paint0_linear_1794_3598)",
    stroke: "#7EA0CF",
    strokeWidth: 64
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1794_3598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573.749 798.233C585.044 798.607 596.258 798.771 607.739 798.791C709.9 798.699 812.173 790.16 913.303 776.101C1014.5 761.906 1114.92 741.581 1213.56 714.998C1224.55 712.037 1235.41 709.02 1246.4 705.893C1235.11 707.652 1223.97 709.368 1212.74 711.093C1111.86 726.556 1011.13 741.171 910.388 755.304C809.704 769.298 708.794 783.403 607.526 794.807C596.137 796.043 585.002 797.208 573.749 798.233Z",
    fill: "#889AC1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1794_3598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M944.785 888.769C936.694 890.168 928.08 891.638 919.893 893.007C769.86 917.623 619.198 939.704 468.167 952.563C459.837 953.232 451.319 953.875 443.064 954.438C440.285 954.628 437.719 955.917 435.933 958.055C434.147 960.19 433.288 963 433.542 965.832C433.795 968.664 435.14 971.277 437.277 973.061C439.414 974.848 442.168 975.661 444.936 975.354C444.936 975.354 444.936 975.354 444.936 975.354C453.251 974.434 461.816 973.436 470.18 972.411C621.625 953.165 771.105 924.859 920.088 894.038C928.212 892.325 936.761 890.511 944.785 888.769Z",
    fill: "#889AC1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1941 246C3157.3 246 4141 1097.85 4141 2146C4141 3194.15 3157.3 4046 1941 4046C724.696 4046 -259 3194.15 -259 2146C-259 1097.85 724.696 246 1941 246Z",
    stroke: "#F9FAFD",
    strokeWidth: 18
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1941 256C3149.97 256 4129 1102.71 4129 2146C4129 3189.29 3149.97 4036 1941 4036C732.032 4036 -247 3189.29 -247 2146C-247 1102.71 732.032 256 1941 256Z",
    stroke: "#ADC3E2",
    strokeWidth: 8
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87,
    filter: "url(#filter2_f_1794_3598)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2211,
    cy: 1618,
    rx: 1415,
    ry: 1118,
    fill: "#333466"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87,
    filter: "url(#filter3_f_1794_3598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3940 1909C3940 2526.45 3306.48 3027 2525 3027C1743.52 3027 1110 2526.45 1110 1909C1110 1291.55 1743.52 791 2525 791C3306.48 791 3940 1291.55 3940 1909Z",
    fill: "#201A4D"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1794_3598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2044.47 816.507C2024.17 862.157 1888.96 897.169 1803.11 913C1788.11 915.765 1778.45 930.671 1782.44 945.393C1785 954.848 1792.73 962.014 1802.35 963.851L1826.55 968.47C1835.71 970.219 1842.34 978.234 1842.34 987.566C1842.34 996.552 1836.19 1004.37 1827.45 1006.47L1794.65 1014.36C1781.86 1017.43 1768.42 1016.38 1756.27 1011.35L1719.99 996.319C1709.76 992.082 1698.29 991.952 1687.97 995.957C1676.6 1000.37 1667.64 1009.39 1663.31 1020.79L1653.62 1046.32C1650.97 1053.31 1652.17 1061.17 1656.8 1067.04C1664.13 1076.33 1662.46 1089.82 1653.1 1097.05L1649.47 1099.85C1644.19 1103.93 1637.53 1105.8 1630.9 1105.08L1611.62 1102.98C1598.92 1101.6 1586.89 1108.94 1582.31 1120.87L1581.53 1122.9C1578.09 1131.87 1580.16 1142.02 1586.84 1148.93C1596.8 1159.23 1595.94 1175.82 1584.96 1185.04L1539.29 1223.35C1535 1226.95 1531.11 1231 1527.59 1235.37C1518.56 1246.57 1506.12 1261.18 1503.45 1261.18C1502.59 1261.18 1503.02 1264.34 1504.25 1269.41C1512.96 1305.29 1548.79 1327.15 1585.61 1324.42L1588.49 1324.21C1599.52 1323.39 1610.58 1325.21 1620.77 1329.52C1634.09 1335.14 1648.82 1336.49 1662.93 1333.38L1695.46 1326.2C1704.96 1324.11 1714.9 1325.27 1723.66 1329.5L1731.24 1333.15C1750.7 1342.54 1757.55 1366.85 1745.85 1385.02C1730.43 1408.96 1747.61 1440.47 1776.08 1440.47H1859.83C1880.9 1440.47 1895.18 1419.02 1887.05 1399.59C1883.18 1390.34 1884.27 1379.77 1889.94 1371.51L1898.56 1358.96C1902.26 1353.57 1905.01 1347.6 1906.7 1341.3L1924.23 1275.8C1928.67 1259.24 1937.28 1244.1 1949.25 1231.83L1969.62 1210.94C1983.39 1196.83 2001.15 1187.29 2020.52 1183.6C2048.83 1178.21 2073.23 1160.42 2087.02 1135.12L2106.89 1098.67C2117.64 1078.95 2134.73 1063.42 2155.38 1054.59L2165.92 1050.08C2185.74 1041.61 2208.15 1041.6 2227.98 1050.06C2232.61 1052.03 2237.04 1054.44 2241.2 1057.26L2256.35 1067.49C2266.97 1074.66 2278.86 1079.73 2291.38 1082.41L2320.07 1088.56C2335.23 1091.8 2351.01 1090.36 2365.33 1084.43L2432.26 1056.69C2437.04 1054.71 2442.5 1057.2 2444.14 1062.12C2445.36 1065.76 2448.77 1068.22 2452.61 1068.22H2457.84C2466.79 1068.22 2474.04 1075.47 2474.04 1084.41V1089.42C2474.04 1092.14 2474.56 1094.84 2475.58 1097.37L2493.58 1141.84C2498.41 1153.76 2500.88 1166.5 2500.88 1179.35V1196.27C2500.88 1217.05 2509.27 1236.95 2524.14 1251.47C2536.94 1263.97 2553.69 1271.63 2571.52 1273.14L2612.35 1276.59C2630.24 1278.11 2648.19 1274.73 2664.46 1267.13C2684.81 1257.64 2706.57 1247.96 2709.08 1248.52C2711.14 1248.98 2713.07 1240.68 2714.58 1230.93C2716.77 1216.83 2712.77 1202.58 2704.69 1190.82L2703.1 1188.5C2697.1 1179.76 2693.89 1169.41 2693.89 1158.8V1138.84C2693.89 1124.94 2703.86 1113.05 2717.55 1110.62C2727.67 1108.83 2737.97 1112.59 2744.55 1120.47L2775.02 1156.96C2779.88 1162.78 2782.54 1170.12 2782.54 1177.69V1180.18C2782.54 1186.05 2784.57 1191.74 2788.3 1196.28C2794.65 1204.03 2795.86 1214.78 2791.38 1223.74L2788.85 1228.8C2784.81 1236.88 2784.14 1246.25 2787 1254.83L2794.3 1276.7C2797.25 1285.55 2801.56 1293.88 2807.07 1301.39L2816.41 1314.12C2819.49 1318.33 2822.26 1322.75 2824.54 1327.44C2830.12 1338.86 2837.25 1354.85 2837.25 1360.45C2837.25 1369.06 2849.91 1379.19 2853.46 1383.74C2857 1388.3 2862.07 1399.95 2863.08 1404.51C2868.21 1427.57 2890.03 1443 2913.66 1443H2932.81C2975.99 1443 3011 1407.99 3011 1364.81V591.532C3011 558.623 2994.81 527.821 2967.7 509.161L2959.17 503.291C2952.55 498.73 2945.4 494.984 2937.87 492.137L2829.49 451.115C2814.94 445.607 2799.3 443.571 2783.82 445.168L2750.48 448.609C2736.22 450.081 2722.44 454.601 2710.09 461.863L2700.58 467.447C2681.74 478.52 2659.2 481.457 2638.15 475.583C2631.1 473.617 2623.82 472.652 2616.51 472.496C2600.1 472.145 2578.55 470.978 2574.34 468.062C2570.74 465.573 2553.25 467.19 2537.14 469.433C2524.34 471.216 2513.19 478.872 2506.33 489.835C2501.78 497.12 2499.37 505.537 2499.37 514.128V516.657C2499.37 530.957 2493.76 544.688 2483.75 554.902L2481.76 556.934C2477.31 561.473 2472.19 565.297 2466.57 568.269L2464.6 569.314C2460.1 571.698 2455.84 574.53 2451.91 577.766L2407.26 614.455C2401.19 619.444 2396.27 625.682 2392.82 632.744C2389.59 639.374 2385.05 645.281 2379.47 650.112L2372.72 655.959L2356.62 668.451C2348.01 675.127 2337.43 678.75 2326.54 678.75C2317.65 678.75 2308.92 676.333 2301.29 671.759L2291.79 666.059C2290.7 665.404 2289.67 664.662 2288.7 663.838L2279.2 655.765C2274.15 651.476 2273.76 643.82 2278.34 639.038C2280.39 636.897 2281.54 634.044 2281.54 631.078V619.112C2281.54 612.702 2280.05 606.38 2277.18 600.647L2273.84 593.966C2266.99 580.27 2264.63 564.766 2267.08 549.651L2268.13 543.228C2269.29 536.054 2271.72 529.142 2275.28 522.811C2284.66 506.166 2301.22 494.797 2320.12 492.018L2324.6 491.359L2341.1 486.983C2346.38 485.583 2350.78 481.934 2353.13 477.003C2357.11 468.667 2354.38 458.673 2346.71 453.519L2335.86 446.226C2332.44 443.921 2328.61 442.265 2324.59 441.339L2263.8 427.373C2254.07 425.137 2244.06 424.371 2234.1 425.102L2185.99 428.629C2177.45 429.254 2169.04 430.973 2160.94 433.742L2089.98 458.011C2081.29 460.984 2073.05 465.139 2065.5 470.361L2010.41 508.428C2008.8 509.538 2007.34 510.837 2006.04 512.297L1991.57 528.627C1989.78 530.638 1990.13 533.748 1992.31 535.321C1994.8 537.123 1994.82 540.834 1992.34 542.659L1957.16 568.552C1953.27 571.422 1948.83 573.484 1944.13 574.62L1911.36 582.528C1898.9 585.535 1887.13 590.909 1876.7 598.358L1858.78 611.158C1843.96 621.744 1833.56 637.427 1829.59 655.203C1827.31 665.384 1822.91 674.967 1816.66 683.325L1800.3 705.232C1797.67 708.754 1796.25 713.032 1796.25 717.428V726.283C1796.25 735.801 1805.56 742.535 1814.6 739.555C1825.75 735.879 1836.19 746.763 1832.05 757.752L1831.36 759.57C1828.47 767.25 1832.33 775.823 1840 778.748L1859.49 786.183C1862.59 787.365 1864.63 790.337 1864.63 793.653C1864.63 802.125 1876.08 804.778 1879.81 797.169L1912.45 730.517C1918.9 717.343 1935.18 712.575 1948.68 718.309C1977.58 730.585 2011.91 737.002 2014.07 706.099C2016.72 668.294 2052.44 680.787 2055.76 718.538C2058.62 751.069 2057.18 787.901 2044.47 816.507Z",
    fill: "url(#paint1_linear_1794_3598)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2044.47 816.507C2024.17 862.157 1888.96 897.169 1803.11 913C1788.11 915.765 1778.45 930.671 1782.44 945.393C1785 954.848 1792.73 962.014 1802.35 963.851L1826.55 968.47C1835.71 970.219 1842.34 978.234 1842.34 987.566C1842.34 996.552 1836.19 1004.37 1827.45 1006.47L1794.65 1014.36C1781.86 1017.43 1768.42 1016.38 1756.27 1011.35L1719.99 996.319C1709.76 992.082 1698.29 991.952 1687.97 995.957C1676.6 1000.37 1667.64 1009.39 1663.31 1020.79L1653.62 1046.32C1650.97 1053.31 1652.17 1061.17 1656.8 1067.04C1664.13 1076.33 1662.46 1089.82 1653.1 1097.05L1649.47 1099.85C1644.19 1103.93 1637.53 1105.8 1630.9 1105.08L1611.62 1102.98C1598.92 1101.6 1586.89 1108.94 1582.31 1120.87L1581.53 1122.9C1578.09 1131.87 1580.16 1142.02 1586.84 1148.93C1596.8 1159.23 1595.94 1175.82 1584.96 1185.04L1539.29 1223.35C1535 1226.95 1531.11 1231 1527.59 1235.37C1518.56 1246.57 1506.12 1261.18 1503.45 1261.18C1502.59 1261.18 1503.02 1264.34 1504.25 1269.41C1512.96 1305.29 1548.79 1327.15 1585.61 1324.42L1588.49 1324.21C1599.52 1323.39 1610.58 1325.21 1620.77 1329.52C1634.09 1335.14 1648.82 1336.49 1662.93 1333.38L1695.46 1326.2C1704.96 1324.11 1714.9 1325.27 1723.66 1329.5L1731.24 1333.15C1750.7 1342.54 1757.55 1366.85 1745.85 1385.02C1730.43 1408.96 1747.61 1440.47 1776.08 1440.47H1859.83C1880.9 1440.47 1895.18 1419.02 1887.05 1399.59C1883.18 1390.34 1884.27 1379.77 1889.94 1371.51L1898.56 1358.96C1902.26 1353.57 1905.01 1347.6 1906.7 1341.3L1924.23 1275.8C1928.67 1259.24 1937.28 1244.1 1949.25 1231.83L1969.62 1210.94C1983.39 1196.83 2001.15 1187.29 2020.52 1183.6C2048.83 1178.21 2073.23 1160.42 2087.02 1135.12L2106.89 1098.67C2117.64 1078.95 2134.73 1063.42 2155.38 1054.59L2165.92 1050.08C2185.74 1041.61 2208.15 1041.6 2227.98 1050.06C2232.61 1052.03 2237.04 1054.44 2241.2 1057.26L2256.35 1067.49C2266.97 1074.66 2278.86 1079.73 2291.38 1082.41L2320.07 1088.56C2335.23 1091.8 2351.01 1090.36 2365.33 1084.43L2432.26 1056.69C2437.04 1054.71 2442.5 1057.2 2444.14 1062.12C2445.36 1065.76 2448.77 1068.22 2452.61 1068.22H2457.84C2466.79 1068.22 2474.04 1075.47 2474.04 1084.41V1089.42C2474.04 1092.14 2474.56 1094.84 2475.58 1097.37L2493.58 1141.84C2498.41 1153.76 2500.88 1166.5 2500.88 1179.35V1196.27C2500.88 1217.05 2509.27 1236.95 2524.14 1251.47C2536.94 1263.97 2553.69 1271.63 2571.52 1273.14L2612.35 1276.59C2630.24 1278.11 2648.19 1274.73 2664.46 1267.13C2684.81 1257.64 2706.57 1247.96 2709.08 1248.52C2711.14 1248.98 2713.07 1240.68 2714.58 1230.93C2716.77 1216.83 2712.77 1202.58 2704.69 1190.82L2703.1 1188.5C2697.1 1179.76 2693.89 1169.41 2693.89 1158.8V1138.84C2693.89 1124.94 2703.86 1113.05 2717.55 1110.62C2727.67 1108.83 2737.97 1112.59 2744.55 1120.47L2775.02 1156.96C2779.88 1162.78 2782.54 1170.12 2782.54 1177.69V1180.18C2782.54 1186.05 2784.57 1191.74 2788.3 1196.28C2794.65 1204.03 2795.86 1214.78 2791.38 1223.74L2788.85 1228.8C2784.81 1236.88 2784.14 1246.25 2787 1254.83L2794.3 1276.7C2797.25 1285.55 2801.56 1293.88 2807.07 1301.39L2816.41 1314.12C2819.49 1318.33 2822.26 1322.75 2824.54 1327.44C2830.12 1338.86 2837.25 1354.85 2837.25 1360.45C2837.25 1369.06 2849.91 1379.19 2853.46 1383.74C2857 1388.3 2862.07 1399.95 2863.08 1404.51C2868.21 1427.57 2890.03 1443 2913.66 1443H2932.81C2975.99 1443 3011 1407.99 3011 1364.81V591.532C3011 558.623 2994.81 527.821 2967.7 509.161L2959.17 503.291C2952.55 498.73 2945.4 494.984 2937.87 492.137L2829.49 451.115C2814.94 445.607 2799.3 443.571 2783.82 445.168L2750.48 448.609C2736.22 450.081 2722.44 454.601 2710.09 461.863L2700.58 467.447C2681.74 478.52 2659.2 481.457 2638.15 475.583C2631.1 473.617 2623.82 472.652 2616.51 472.496C2600.1 472.145 2578.55 470.978 2574.34 468.062C2570.74 465.573 2553.25 467.19 2537.14 469.433C2524.34 471.216 2513.19 478.872 2506.33 489.835C2501.78 497.12 2499.37 505.537 2499.37 514.128V516.657C2499.37 530.957 2493.76 544.688 2483.75 554.902L2481.76 556.934C2477.31 561.473 2472.19 565.297 2466.57 568.269L2464.6 569.314C2460.1 571.698 2455.84 574.53 2451.91 577.766L2407.26 614.455C2401.19 619.444 2396.27 625.682 2392.82 632.744C2389.59 639.374 2385.05 645.281 2379.47 650.112L2372.72 655.959L2356.62 668.451C2348.01 675.127 2337.43 678.75 2326.54 678.75C2317.65 678.75 2308.92 676.333 2301.29 671.759L2291.79 666.059C2290.7 665.404 2289.67 664.662 2288.7 663.838L2279.2 655.765C2274.15 651.476 2273.76 643.82 2278.34 639.038C2280.39 636.897 2281.54 634.044 2281.54 631.078V619.112C2281.54 612.702 2280.05 606.38 2277.18 600.647L2273.84 593.966C2266.99 580.27 2264.63 564.766 2267.08 549.651L2268.13 543.228C2269.29 536.054 2271.72 529.142 2275.28 522.811C2284.66 506.166 2301.22 494.797 2320.12 492.018L2324.6 491.359L2341.1 486.983C2346.38 485.583 2350.78 481.934 2353.13 477.003C2357.11 468.667 2354.38 458.673 2346.71 453.519L2335.86 446.226C2332.44 443.921 2328.61 442.265 2324.59 441.339L2263.8 427.373C2254.07 425.137 2244.06 424.371 2234.1 425.102L2185.99 428.629C2177.45 429.254 2169.04 430.973 2160.94 433.742L2089.98 458.011C2081.29 460.984 2073.05 465.139 2065.5 470.361L2010.41 508.428C2008.8 509.538 2007.34 510.837 2006.04 512.297L1991.57 528.627C1989.78 530.638 1990.13 533.748 1992.31 535.321C1994.8 537.123 1994.82 540.834 1992.34 542.659L1957.16 568.552C1953.27 571.422 1948.83 573.484 1944.13 574.62L1911.36 582.528C1898.9 585.535 1887.13 590.909 1876.7 598.358L1858.78 611.158C1843.96 621.744 1833.56 637.427 1829.59 655.203C1827.31 665.384 1822.91 674.967 1816.66 683.325L1800.3 705.232C1797.67 708.754 1796.25 713.032 1796.25 717.428V726.283C1796.25 735.801 1805.56 742.535 1814.6 739.555C1825.75 735.879 1836.19 746.763 1832.05 757.752L1831.36 759.57C1828.47 767.25 1832.33 775.823 1840 778.748L1859.49 786.183C1862.59 787.365 1864.63 790.337 1864.63 793.653C1864.63 802.125 1876.08 804.778 1879.81 797.169L1912.45 730.517C1918.9 717.343 1935.18 712.575 1948.68 718.309C1977.58 730.585 2011.91 737.002 2014.07 706.099C2016.72 668.294 2052.44 680.787 2055.76 718.538C2058.62 751.069 2057.18 787.901 2044.47 816.507Z",
    stroke: "url(#paint2_linear_1794_3598)",
    strokeWidth: 5
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1794_3598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1049.39 1103.12L1053.03 1104.75C1058.45 1107.19 1064.62 1107.38 1070.19 1105.28C1081.11 1101.16 1093.37 1106.09 1098.41 1116.62L1099.98 1119.89C1103.75 1127.75 1103.4 1136.97 1099.04 1144.53L1077.37 1182.1C1071.64 1192.03 1069.58 1203.67 1071.54 1214.97L1073.35 1225.36C1075.6 1238.33 1084.73 1249.04 1097.17 1253.34C1102.96 1255.33 1108.15 1258.77 1112.25 1263.33L1118.37 1270.13C1126.5 1279.17 1137.69 1284.86 1149.78 1286.1L1183.86 1289.61C1198.21 1291.09 1211.19 1298.83 1219.32 1310.76L1260.49 1371.16C1266.03 1379.29 1269 1388.91 1269 1398.75V1462H661L655.978 1449.98C650.878 1437.77 650.933 1424.01 656.131 1411.84L668.775 1382.24C670.583 1378.01 672.977 1374.05 675.888 1370.49L703.715 1336.42C705.236 1334.56 706.618 1332.59 707.85 1330.53L721.245 1308.07C730.085 1293.25 746.07 1284.17 763.328 1284.17H797.5C806.5 1284.17 841 1273.61 849.5 1270.83C852.893 1269.72 855.598 1265.43 857.601 1260.51C861.213 1251.64 864.952 1242.62 871.43 1235.56L874.102 1232.65C882.397 1223.61 887 1211.79 887 1199.52V1193.59C887 1185.92 888.805 1178.34 892.269 1171.49L907.266 1141.82C910.387 1135.65 914.779 1130.2 920.154 1125.85L932.588 1115.78C938.45 1111.03 945.33 1107.7 952.69 1106.04L979.2 1100.09C985.168 1098.75 991.424 1099.76 996.661 1102.92C1002.59 1106.5 1009.78 1107.31 1016.36 1105.14L1026.14 1101.91C1033.77 1099.4 1042.06 1099.83 1049.39 1103.12Z",
    fill: "url(#paint3_linear_1794_3598)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.39 1103.12L1053.03 1104.75C1058.45 1107.19 1064.62 1107.38 1070.19 1105.28C1081.11 1101.16 1093.37 1106.09 1098.41 1116.62L1099.98 1119.89C1103.75 1127.75 1103.4 1136.97 1099.04 1144.53L1077.37 1182.1C1071.64 1192.03 1069.58 1203.67 1071.54 1214.97L1073.35 1225.36C1075.6 1238.33 1084.73 1249.04 1097.17 1253.34C1102.96 1255.33 1108.15 1258.77 1112.25 1263.33L1118.37 1270.13C1126.5 1279.17 1137.69 1284.86 1149.78 1286.1L1183.86 1289.61C1198.21 1291.09 1211.19 1298.83 1219.32 1310.76L1260.49 1371.16C1266.03 1379.29 1269 1388.91 1269 1398.75V1462H661L655.978 1449.98C650.878 1437.77 650.933 1424.01 656.131 1411.84L668.775 1382.24C670.583 1378.01 672.977 1374.05 675.888 1370.49L703.715 1336.42C705.236 1334.56 706.618 1332.59 707.85 1330.53L721.245 1308.07C730.085 1293.25 746.07 1284.17 763.328 1284.17H797.5C806.5 1284.17 841 1273.61 849.5 1270.83C852.893 1269.72 855.598 1265.43 857.601 1260.51C861.213 1251.64 864.952 1242.62 871.43 1235.56L874.102 1232.65C882.397 1223.61 887 1211.79 887 1199.52V1193.59C887 1185.92 888.805 1178.34 892.269 1171.49L907.266 1141.82C910.387 1135.65 914.779 1130.2 920.154 1125.85L932.588 1115.78C938.45 1111.03 945.33 1107.7 952.69 1106.04L979.2 1100.09C985.168 1098.75 991.424 1099.76 996.661 1102.92C1002.59 1106.5 1009.78 1107.31 1016.36 1105.14L1026.14 1101.91C1033.77 1099.4 1042.06 1099.83 1049.39 1103.12Z",
    stroke: "url(#paint4_linear_1794_3598)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1794_3598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1332.62 622.087C1331.72 625.724 1330.87 629.546 1330.27 632.901C1329.24 638.646 1331.9 643.885 1336.21 647.822L1343.21 654.217C1357.02 666.84 1376.06 673.017 1394.07 667.937C1398.29 666.747 1401.75 665.536 1403.58 664.417C1405.73 663.098 1410.6 659.829 1416.49 655.811C1435.96 642.522 1448.77 621.53 1452.08 598.189L1454.75 579.276C1455.83 571.667 1459.17 564.56 1464.35 558.877L1468.61 554.191C1472.83 549.556 1475 543.414 1474.63 537.157C1473.98 526.258 1465.83 517.28 1455.04 515.578L1425.16 510.863C1416.05 509.426 1406.74 510.078 1397.92 512.769L1381.83 517.677C1365.58 522.635 1352.31 534.459 1345.52 550.034L1345.15 550.899C1344.02 553.497 1342.65 555.988 1341.08 558.344L1322.51 586.101C1318.08 592.72 1319.88 601.679 1326.52 606.069C1331.76 609.531 1334.12 615.988 1332.62 622.087Z",
    fill: "#285D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.28 325.346C1348.83 323.524 1427.07 307.793 1469.34 299.415C1472.02 298.885 1474.78 299.046 1477.38 299.881C1488.46 303.449 1492.18 317.246 1484.28 325.809C1450.01 362.988 1400.22 414.64 1388.84 417.356C1378.63 419.793 1356.44 432.9 1339.61 443.631C1331.03 449.103 1320.2 449.814 1311.13 445.209C1303.16 441.167 1293.77 441.171 1285.78 445.174C1257.23 459.492 1214.59 480.283 1204.42 482.956C1194.08 485.673 1140.02 511.536 1104.46 528.921C1095.15 533.473 1085.04 536.161 1074.69 536.778L1062.45 537.508C1055.27 537.937 1048.11 536.249 1041.88 532.654C1033.39 527.756 1023.31 526.453 1013.84 528.996C980.251 538.015 930.902 550.867 922.993 551.338L901.487 552.622C892.414 553.163 884.622 546.247 884.08 537.175C883.941 534.843 883.307 532.568 882.221 530.5L882.096 530.262C878.454 523.332 879.797 514.832 885.397 509.361L910.453 484.886C915.814 479.649 922.023 475.395 928.842 472.282C969.93 453.523 1037.53 422.328 1044.26 417.879C1053.42 411.823 1186.57 376.831 1197.93 374.15C1209.29 371.468 1338.41 327.7 1344.28 325.346Z",
    fill: "#285D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332.62 622.087C1331.72 625.724 1330.87 629.546 1330.27 632.901C1329.24 638.646 1331.9 643.885 1336.21 647.822L1343.21 654.217C1357.02 666.84 1376.06 673.017 1394.07 667.937C1398.29 666.747 1401.75 665.536 1403.58 664.417C1405.73 663.098 1410.6 659.829 1416.49 655.811C1435.96 642.522 1448.77 621.53 1452.08 598.189L1454.75 579.276C1455.83 571.667 1459.17 564.56 1464.35 558.877L1468.61 554.191C1472.83 549.556 1475 543.414 1474.63 537.157C1473.98 526.258 1465.83 517.28 1455.04 515.578L1425.16 510.863C1416.05 509.426 1406.74 510.078 1397.92 512.769L1381.83 517.677C1365.58 522.635 1352.31 534.459 1345.52 550.034L1345.15 550.899C1344.02 553.497 1342.65 555.988 1341.08 558.344L1322.51 586.101C1318.08 592.72 1319.88 601.679 1326.52 606.069C1331.76 609.531 1334.12 615.988 1332.62 622.087Z",
    stroke: "url(#paint5_linear_1794_3598)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.28 325.346C1348.83 323.524 1427.07 307.793 1469.34 299.415C1472.02 298.885 1474.78 299.046 1477.38 299.881C1488.46 303.449 1492.18 317.246 1484.28 325.809C1450.01 362.988 1400.22 414.64 1388.84 417.356C1378.63 419.793 1356.44 432.9 1339.61 443.631C1331.03 449.103 1320.2 449.814 1311.13 445.209C1303.16 441.167 1293.77 441.171 1285.78 445.174C1257.23 459.492 1214.59 480.283 1204.42 482.956C1194.08 485.673 1140.02 511.536 1104.46 528.921C1095.15 533.473 1085.04 536.161 1074.69 536.778L1062.45 537.508C1055.27 537.937 1048.11 536.249 1041.88 532.654C1033.39 527.756 1023.31 526.453 1013.84 528.996C980.251 538.015 930.902 550.867 922.993 551.338L901.487 552.622C892.414 553.163 884.622 546.247 884.08 537.175C883.941 534.843 883.307 532.568 882.221 530.5L882.096 530.262C878.454 523.332 879.797 514.832 885.397 509.361L910.453 484.886C915.814 479.649 922.023 475.395 928.842 472.282C969.93 453.523 1037.53 422.328 1044.26 417.879C1053.42 411.823 1186.57 376.831 1197.93 374.15C1209.29 371.468 1338.41 327.7 1344.28 325.346Z",
    stroke: "url(#paint6_linear_1794_3598)",
    strokeWidth: 4
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1794_3598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1706.04 354.486C1708.53 353.233 1710.38 351.056 1711.15 348.378C1711.92 345.704 1711.55 342.747 1710.15 340.215C1708.74 337.683 1706.44 335.798 1703.76 335.03C1701.09 334.259 1698.26 334.667 1695.88 336.111C1695.88 336.111 1695.88 336.111 1695.88 336.111C1693.68 337.399 1692.93 338.443 1692.55 338.818C1692.11 339.311 1691.63 339.91 1691.38 340.24C1690.83 340.96 1690.25 341.789 1689.85 342.384C1688.9 343.791 1688.15 344.981 1687.37 346.23C1661.3 389.856 1631.85 430.835 1593.48 463.725C1591.36 465.542 1589.22 467.327 1587.03 469.094C1586.25 469.727 1585.75 470.663 1585.62 471.679C1585.49 472.697 1585.75 473.71 1586.35 474.516C1586.96 475.321 1587.85 475.857 1588.87 476.024C1589.88 476.19 1590.92 475.974 1591.75 475.404C1591.75 475.404 1591.75 475.404 1591.75 475.404C1594.12 473.768 1596.46 472.11 1598.77 470.418C1640.57 439.939 1674.76 399.305 1704.19 357.675C1705 356.576 1705.78 355.539 1706.58 354.531C1706.92 354.113 1707.35 353.581 1707.59 353.329C1707.71 353.205 1707.85 353.059 1707.82 353.114C1707.78 353.122 1707.82 353.399 1706.04 354.486Z",
    fill: "#889AC1"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_1794_3598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1599.54 539.912C1596.93 540.867 1594.82 542.819 1593.69 545.366C1592.56 547.913 1592.51 550.846 1593.54 553.493C1594.56 556.14 1596.57 558.276 1599.12 559.401C1601.67 560.528 1604.54 560.553 1607.12 559.498C1607.12 559.498 1607.12 559.498 1607.12 559.498C1612.74 557.204 1618.27 554.544 1623.72 551.657C1715.02 495.95 1792.78 423.485 1847.17 332.103C1849.67 326.663 1851.94 320.899 1852.96 314.684C1853.12 313.671 1852.86 312.628 1852.26 311.787C1851.66 310.945 1850.76 310.373 1849.75 310.195C1848.74 310.017 1847.7 310.247 1846.85 310.833C1846 311.418 1845.4 312.311 1845.2 313.316C1845.2 313.316 1845.2 313.316 1845.2 313.316C1844.21 318.253 1842.01 323.447 1839.5 328.374C1784.68 413.605 1702 484.907 1614.51 533.516C1609.44 535.964 1604.41 538.145 1599.54 539.912Z",
    fill: "#889AC1"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_1794_3598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2218.55 1427.58C2209.44 1432.43 2201.19 1435.49 2195.11 1437.33C2198.12 1439.87 2200.67 1442.5 2202.8 1444.43C2209.75 1446.58 2221.7 1448.64 2245.98 1447.42C2253.03 1447.07 2265.14 1447.71 2290.06 1445.45C2305.31 1444.07 2325.43 1441.38 2340.08 1440.04C2354.72 1438.69 2363.62 1438.85 2368.79 1438.57C2375.39 1438.22 2394.24 1438.64 2420.33 1437.88C2430.97 1437.57 2436.26 1438.55 2437.43 1435.31C2439.68 1429.06 2439.75 1421.07 2438.49 1413.92C2437.17 1406.47 2431.87 1399.35 2427.22 1388.16C2424.12 1380.69 2420.21 1366.42 2426.53 1349.67C2430.9 1338.07 2435.47 1329.54 2431.34 1321.94C2427.57 1315.02 2419.09 1304.22 2415.72 1293.81C2410.24 1276.87 2409.87 1261.31 2412.09 1253.43C2413.94 1246.83 2421.46 1236.75 2416.77 1224.88C2413.54 1216.7 2407.65 1203.03 2398.77 1200.97L2398.37 1200.88C2392.95 1199.62 2388.13 1198.5 2385.09 1199.23C2379.35 1200.62 2371.14 1202.84 2363.63 1211.65C2358.17 1218.05 2354.84 1228.75 2348.1 1239.25C2340.18 1251.58 2331.45 1254.91 2325.39 1259.65C2318.76 1264.83 2314.22 1273.69 2303.78 1281.27C2294.45 1288.04 2275.39 1299.83 2262.93 1303.67C2247.67 1308.37 2229.78 1314.76 2222.29 1326.31C2216.94 1334.55 2214.25 1347.48 2215.42 1356.2C2216.38 1363.39 2217.89 1373.19 2221.63 1385.63C2223.98 1393.46 2230.62 1399.9 2232.09 1407.26C2232.82 1410.94 2232.92 1415 2230.3 1417.91C2227.28 1421.28 2223.92 1424.72 2218.55 1427.58Z",
    fill: "#171140"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_1794_3598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1426.54 894.697L1442.04 876.896C1444.01 874.64 1446.23 872.619 1448.66 870.875L1450.53 869.536C1463.88 859.96 1480.66 856.463 1496.73 859.907L1507.84 862.288C1516.13 864.063 1523.77 868.054 1529.96 873.836C1542.86 885.892 1548.03 904.254 1542.22 920.929C1538.14 932.643 1533.82 943.463 1531 946.5C1528.05 949.673 1519.51 956.313 1510.72 962.837C1498.97 971.553 1484.65 976 1470.02 976H1446.84C1439.07 976 1431.76 972.341 1427.09 966.125C1421.51 958.687 1420.59 948.745 1424.7 940.404L1430.09 929.456C1432.72 924.118 1431.61 917.693 1427.33 913.55C1422.1 908.476 1421.75 900.194 1426.54 894.697Z",
    fill: "#194827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.54 894.697L1442.04 876.896C1444.01 874.64 1446.23 872.619 1448.66 870.875L1450.53 869.536C1463.88 859.96 1480.66 856.463 1496.73 859.907L1507.84 862.288C1516.13 864.063 1523.77 868.054 1529.96 873.836C1542.86 885.892 1548.03 904.254 1542.22 920.929C1538.14 932.643 1533.82 943.463 1531 946.5C1528.05 949.673 1519.51 956.313 1510.72 962.837C1498.97 971.553 1484.65 976 1470.02 976H1446.84C1439.07 976 1431.76 972.341 1427.09 966.125C1421.51 958.687 1420.59 948.745 1424.7 940.404L1430.09 929.456C1432.72 924.118 1431.61 917.693 1427.33 913.55C1422.1 908.476 1421.75 900.194 1426.54 894.697Z",
    stroke: "url(#paint7_linear_1794_3598)",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 2041.5,
    cy: 1139.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2037.5,
    cy: 1167.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2012.5,
    cy: 1186.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2012.5,
    cy: 1143.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1984.5,
    cy: 1072.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2006.5,
    cy: 1046.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2162.5,
    cy: 1056.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2188,
    cy: 1027,
    r: 10,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2188,
    cy: 1047.5,
    rx: 10,
    ry: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    cx: 2204.5,
    cy: 1038,
    rx: 9.5,
    ry: 10,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2235.5,
    cy: 1029,
    rx: 9.5,
    ry: 10,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2260.5,
    cy: 1043.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2316.5,
    cy: 1084.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2325.5,
    cy: 1065.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2362.5,
    cy: 1084.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2406.5,
    cy: 1317.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2797,
    cy: 1228.5,
    rx: 10,
    ry: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2818.5,
    cy: 1213.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2840.5,
    cy: 1189.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2837.5,
    cy: 1244.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.43,
    cx: 2802.5,
    cy: 1274,
    rx: 9.5,
    ry: 10,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2772.5,
    cy: 1143.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2346.5,
    cy: 1317.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2372.5,
    cy: 1070.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2371.5,
    cy: 1043.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2391.5,
    cy: 1037,
    rx: 9.5,
    ry: 10,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2417,
    cy: 1037,
    r: 10,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2410.5,
    cy: 1051.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2400.5,
    cy: 1065.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2370.5,
    cy: 1322.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2380.5,
    cy: 1062.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2378.5,
    cy: 1349.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 2430,
    cy: 1041,
    r: 10,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.43,
    cx: 2448.5,
    cy: 1029,
    rx: 9.5,
    ry: 10,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2485.5,
    cy: 1007.5,
    r: 12.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2507.5,
    cy: 1033,
    rx: 12.5,
    ry: 13,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 2470.5,
    cy: 1048.5,
    r: 12.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2368.5,
    cy: 1285,
    rx: 12.5,
    ry: 13,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2790,
    cy: 1180.5,
    rx: 13,
    ry: 12.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 1990.5,
    cy: 1173.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 1956.5,
    cy: 1202.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    cx: 1929,
    cy: 1245.5,
    rx: 10,
    ry: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 1901.5,
    cy: 1259.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1923.5,
    cy: 1274,
    rx: 9.5,
    ry: 10,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 1911.5,
    cy: 1298.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 1877.5,
    cy: 1293.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1904.5,
    cy: 1317.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 1868.5,
    cy: 1321.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 1891.5,
    cy: 1347.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 1772.5,
    cy: 1371.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1743.5,
    cy: 1425.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 1716.5,
    cy: 1317.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.43,
    cx: 1641.5,
    cy: 1317.5,
    r: 9.5,
    fill: "#AD9C4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1772.5,
    cy: 1412.5,
    r: 12.5,
    fill: "#AD9C4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1794_3598",
    x: 554.649,
    y: 686.793,
    width: 710.847,
    height: 131.098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.55,
    result: "effect1_foregroundBlur_1794_3598"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1794_3598",
    x: 414.398,
    y: 869.669,
    width: 549.487,
    height: 124.848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.55,
    result: "effect1_foregroundBlur_1794_3598"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1794_3598",
    x: 296,
    y: 0,
    width: 3830,
    height: 3236,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_1794_3598"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1794_3598",
    x: 610,
    y: 291,
    width: 3830,
    height: 3236,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_1794_3598"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1794_3598",
    x: 1487.1,
    y: 408.934,
    width: 1539.8,
    height: 1049.97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.7,
    result: "effect1_foregroundBlur_1794_3598"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1794_3598",
    x: 638.292,
    y: 1085.61,
    width: 644.608,
    height: 390.288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.7,
    result: "effect1_foregroundBlur_1794_3598"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1794_3598",
    x: 864.663,
    y: 283.709,
    width: 639.232,
    height: 401.408,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.7,
    result: "effect1_foregroundBlur_1794_3598"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1794_3598",
    x: 1566.49,
    y: 315.547,
    width: 164.152,
    height: 179.632,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.55,
    result: "effect1_foregroundBlur_1794_3598"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1794_3598",
    x: 1573.71,
    y: 291.036,
    width: 298.399,
    height: 288.332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.55,
    result: "effect1_foregroundBlur_1794_3598"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_1794_3598",
    x: 1417.16,
    y: 853.612,
    width: 1436.84,
    height: 598.174,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1794_3598"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_1794_3598",
    x: 1407.76,
    y: 844.212,
    width: 151.235,
    height: 146.188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.7,
    result: "effect1_foregroundBlur_1794_3598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1794_3598",
    x1: 1251,
    y1: 450,
    x2: 1728.5,
    y2: 1820.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#647BAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#424B7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1794_3598",
    x1: 2257,
    y1: 424,
    x2: 2539.5,
    y2: 1298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#225232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64555,
    stopColor: "#07271B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1794_3598",
    x1: 1993.5,
    y1: 452,
    x2: 2089,
    y2: 658.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1794_3598",
    x1: 1041.5,
    y1: 1125,
    x2: 910,
    y2: 1442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C532D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C2F22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1794_3598",
    x1: 1063.5,
    y1: 1132.5,
    x2: 924,
    y2: 1486.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1794_3598",
    x1: 1332.5,
    y1: 332.5,
    x2: 1204.63,
    y2: 683.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1794_3598",
    x1: 1332.5,
    y1: 332.5,
    x2: 1204.63,
    y2: 683.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1794_3598",
    x1: 1468.5,
    y1: 854,
    x2: 1484.5,
    y2: 976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth1);
export default __webpack_public_path__ + "static/media/earth1.18326891b5d823ae3e39730567688e27.svg";
export { ForwardRef as ReactComponent };